import { main } from './main-impl';

main(process.argv);
